export default __webpack_public_path__ + "static/media/tapicerowane5.6f570936.jpg";